module.exports = __webpack_public_path__ + "static/media/aura_video.88226b30.mov";